import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { Divider, Grid, Typography } from "@mui/material";
import { FiltrosHistorico } from "./components/filtros";
import { ReporteIndividual } from "../../../hooks/reportes";
import { ThemeContext } from "@emotion/react";
import { useLoading } from "../../../components/Loading/useLoading";
import { exportToExcel } from "react-json-to-excel";
import { AyudasVisualesPanel } from "../../inventario/panel_control/components/ayudasVisuales";
import { TablaHistorico } from "./components/tablaHistorico";
import { DownloadExcel, ReporteGeneralHistorico } from "../../../hooks/existenciasHistorico";


export const HistoricoIndex = () => {

  const dispatch = useDispatch();
  const theme = useContext(ThemeContext);
  const { setAppLoading } = useLoading();
  const { reporteGeneralHistoricoMutation } = ReporteGeneralHistorico();
  const { getDownloadExcel } = DownloadExcel();
  const [sample, setSample] = useState([]);
  const [where, setWhere] = useState(null);
  const [openAyudas, setOpenAyudas] = useState(false);
  const [ayudasVisuales, setAyudasVisuales] = useState(null);
  const { reporteIndividualMutation } = ReporteIndividual();

  useEffect(() => {
    dispatch(
      HEADER_DATA_UPDATE({ nombreData: null })
    )
  }, []);

  const search = (body) => {
    setWhere(body)
    setAppLoading(true);
    reporteGeneralHistoricoMutation(body, {
      onSuccess: (data) => {
        if (data.success) {
          setSample(data?.data);
        }
      },
      onError: (error) => {
        console.log(error)
        setAppLoading(false);
      },
      onSettled: () => {
        setAppLoading(false);
      }
    })
  }

  const exportExcel = async () => {
    setAppLoading(true);
    getDownloadExcel(where, {
      onSuccess: (data) => {
        const blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `galus_reporte_${where?.fecha_fin ? 'historico' : 'existencas'}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      onError: (error) => {
        console.error('Error al descargar el Excel', error);
      },
      onSettled: () => {
        setAppLoading(false);
      }
    })
  }


  return (
    <>
      <Grid container spacing={0} sx={{ height: '87vh' }}>
        <Grid item xs={12} sx={{ padding: '10px 20px', flexDirection: 'column', justifyContent: 'flex-start' }} className="center_item">
          <FiltrosHistorico key='filtros_existencias' search={search} size={sample.length} export_data={exportExcel} />
          <Divider sx={{ width: '100%', mt: 1, mb: 2 }} />

          {
            sample.length > 0 &&
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: 22,
                mb: 2,
                color: theme.palette.primary.main
              }}>
              Resultados de Búsqueda
            </Typography>
          }

          <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={openAyudas ? 10 : 12} lg={openAyudas ? 10 : 12} xl={openAyudas ? 10 : 12} sx={{ p: 1, alignItems: 'flex-start' }} className="center_item">
              {
                <TablaHistorico key='tablas_almacen' sample={sample} where={where} setAyudasVisuales={setAyudasVisuales} setOpenAyudas={setOpenAyudas} />
              }
            </Grid>
            <Grid item xs={12} sm={12} md={openAyudas ? 2 : 0} lg={openAyudas ? 2 : 0} xl={openAyudas ? 2 : 0} sx={{ p: 1 }}>
              {
                openAyudas && ayudasVisuales &&
                <AyudasVisualesPanel
                  id_part={ayudasVisuales}
                  setAyudas={setAyudasVisuales}
                  setOpenAyudas={setOpenAyudas} />
              }
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}